<template>
  <div>
    <v-container fluid class="content-wrapper">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Users
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-row>
              <v-col cols="12" md="4">
                <search-text
                  :text="'Search by name or email'"
                  :value="'text'"
                  @searchTextChanged="searchTextChanged"
                  @keypress.enter.native.prevent="triggerSearch"
                  @triggerSearch="triggerSearch"
                  @triggerClear="clear"
                  data-cy="name"
                ></search-text>
              </v-col>
            </v-row>
            <TableUsers
              ref="table"
              :url-api="'/api/v1/users/keycloak'"
              :search="search"
              :search-attributes="['text']"
              @delete="deleteHandler"
              :key="tableKey"
            >
            </TableUsers>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import SearchText from '@/components/shared/search/SearchText';
import TableUsers from '@/components/admin/users/TableUsers';

export default {
  name: 'Users',
  mixins: [util],
  components: {
    TableUsers,
    SearchText,
  },
  data: () => ({
    search: {},
    tableKey: 0,
  }),
  methods: {
    triggerSearch() {
      this.$refs.table.triggerSearch();
    },
    searchTextChanged(obj) {
      console.log('[App] searchTextChanged');
      this.search[obj.value] = obj.search;
    },
    clear() {
      EventBus.$emit('clear');
      this.$nextTick(() => {
        this.triggerSearch();
        this.forceTableRerender();
      });
    },
    deleteHandler() {
      this.forceTableRerender();
    },
    forceTableRerender() {
      this.tableKey += 1;
    },
  },
};
</script>
